import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, ArrowRight, Code, Database, Cog, Layers } from 'lucide-react';

const DevelopmentSection = () => {
  const developmentAreas = [
    {
      icon: <Code className="h-8 w-8 text-blue-600" />,
      area: "Custom E-Commerce Development",
      approach: "Individuelle Shopware 6 Entwicklung mit maßgeschneiderten Plugins",
      result: "Perfekt auf deine Geschäftsprozesse zugeschnittene E-Commerce-Plattform"
    },
    {
      icon: <Database className="h-8 w-8 text-green-600" />,
      area: "System-Integration & APIs",
      approach: "Professionelle Anbindung von ERP, CRM und Warenwirtschaftssystemen",
      result: "Nahtloser Datenfluss zwischen allen Unternehmenssystemen"
    },
    {
      icon: <Layers className="h-8 w-8 text-purple-600" />,
      area: "Multi-Channel-Architektur",
      approach: "Zentrale Plattform mit intelligenter Kanalsteuerung",
      result: "Einheitliche Verwaltung aller Verkaufskanäle und Marktplätze"
    },
    {
      icon: <Cog className="h-8 w-8 text-orange-600" />,
      area: "Workflow-Automatisierung",
      approach: "Programmierung komplexer Geschäftslogik und Automatismen",
      result: "Effiziente, automatisierte Prozesse ohne manuelle Eingriffe"
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-green-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Professionelle <span className="text-blue-600">E-Commerce-Entwicklung</span>
          </h2>
          <p className="text-lg text-gray-600">
            Wir programmieren und entwickeln E-Commerce-Lösungen, die komplexe Anforderungen 
            mittelständischer Unternehmen erfüllen. Technisch fundiert, zukunftssicher, skalierbar.
          </p>
        </div>

        {/* Development Areas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {developmentAreas.map((item, index) => (
            <Card key={index} className="border-0 shadow-lg bg-white">
              <CardContent className="p-8">
                <div className="flex items-center mb-4">
                  {item.icon}
                  <h3 className="text-lg font-bold ml-3">
                    {item.area}
                  </h3>
                </div>
                
                <div className="mb-4">
                  <h4 className="font-semibold text-blue-600 mb-2">Unser Ansatz:</h4>
                  <p className="text-gray-700">{item.approach}</p>
                </div>
                
                <div className="bg-green-50 rounded-lg p-4 border-l-4 border-green-400">
                  <h4 className="font-semibold text-green-800 mb-1">Das Ergebnis:</h4>
                  <p className="text-green-700">{item.result}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="bg-white rounded-xl shadow-xl p-8 max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-6 mb-6">
            <h4 className="font-bold text-gray-900 mb-2">
              💻 Bereit für eine maßgeschneiderte E-Commerce-Lösung?
            </h4>
            <p className="text-gray-700">
              Lass uns gemeinsam analysieren, welche technischen Anforderungen dein Unternehmen hat 
              und wie wir diese optimal in einer E-Commerce-Plattform umsetzen können.
            </p>
          </div>
          <a 
            href="#contact" 
            className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200"
          >
            Entwicklungsgespräch vereinbaren
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default DevelopmentSection; 